import * as React from 'react';

import { Link as RouterLink } from 'react-router-dom'
import { Box, Flex, HStack, IconButton, Heading, Text, Image, Button, Stack, useDisclosure, Link } from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons'

import { checkNetwork, refreshToken } from '../service/api/token';
import logoImage from '../assets/images/logo512.png'


const AuthGuard = ({ component }) => {
    const [authenticated, setAuthenticated] = React.useState(false)
    const { isOpen, onOpen, onClose } = useDisclosure();

    React.useEffect(() => {

        if (localStorage.getItem('access_token')) {
            setAuthenticated(true);


        } else {
            window.location.href = '/login';
        };

    }, []);

    if (authenticated) {
        return (
            <div>
                <Box bg="#f3e2d6" px={4}>
                    <Flex h={16} alignItems="center" justifyContent="space-between">
                        <Box><Image
                            src={logoImage}
                            alt="Home Image"
                            borderRadius="md"
                            mb={{ base: 4, md: 0 }}
                            mr={{ md: 4 }}
                            boxSize={{ base: '50px' }}
                        /></Box>
                        <HStack as="nav" spacing={4} display={{ base: 'none', md: 'flex' }}>
                            <Box>
                                <Link as={RouterLink} to="/" color="teal.500" mt={4}>Home</Link>
                            </Box>
                            <Box>
                                <Link as={RouterLink} to="/event/guests/rsvp" color="teal.500" mt={4} >RSVP</Link>
                            </Box>
                            <Box>
                                <Link as={RouterLink} to="/event/guests" color="teal.500" mt={4} >Guest Response</Link>
                            </Box>
                            <Box>
                                <Link as={RouterLink} to="/admin/dispocam" color="teal.500" mt={4} >Dispo-Cam</Link>
                            </Box>
                            <Box>
                                <Link as={RouterLink} to="/logout" color="teal.500" mt={4}>Logout</Link>
                            </Box>
                        </HStack>
                        <IconButton
                            size="md"
                            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
                            aria-label="Open Menu"
                            display={{ md: 'none' }}
                            onClick={isOpen ? onClose : onOpen}
                        />
                    </Flex>

                    {isOpen ? (
                        <Box pb={4} display={{ md: 'none' }}>
                            <Stack as="nav" spacing={4}>
                                <Box>
                                    <Link as={RouterLink} to="/" color="teal.500" mt={4}>Home</Link>
                                </Box>
                                <Box>
                                    <Link as={RouterLink} to="/event/guests/rsvp" color="teal.500" mt={4} >RSVP</Link>
                                </Box>
                                <Box>
                                    <Link as={RouterLink} to="/event/guests" color="teal.500" mt={4} >Guest Response</Link>
                                </Box>
                                <Box>
                                    <Link as={RouterLink} to="/admin/dispocam" color="teal.500" mt={4} >Dispo-Cam</Link>
                                </Box>
                                <Box>
                                    <Link as={RouterLink} to="/logout" color="teal.500" mt={4}>Logout</Link>
                                </Box>
                            </Stack>
                        </Box>
                    ) : null}
                </Box>
                <React.Fragment>
                    {component}
                </React.Fragment>

            </div>
        )
    }


}

export default AuthGuard;